import { ChangeDetectionStrategy, Component, inject, Input, output } from '@angular/core';
import { MngActionDef } from '@mng/mng-inputs';
import { removeParams } from '../frame.logic';
import { Location } from '@angular/common';
import { FlexDirective, LayoutAlignDirective, LayoutDirective } from '@ngbracket/ngx-layout/flex';
import { MngIconComponent } from '@mng/mng-icon';
import { MatListItem, MatListItemAvatar, MatNavList } from '@angular/material/list';

@Component({
  selector: 'mng-sidenav-button',
  imports: [
    MatListItem,
    MngIconComponent,
    MatListItemAvatar,
    LayoutDirective,
    LayoutAlignDirective,
    FlexDirective,
    MatNavList
  ],
  templateUrl: './mng-sidenav-button.component.html',
  styleUrl: './mng-sidenav-button.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MngSidenavButtonComponent {
  private location = inject(Location);

  @Input()
  actionDef: MngActionDef;

  @Input()
  active: boolean;

  readonly executeAction = output<MngActionDef>();

  showSubanv(): boolean {
    return this.actionDef?.menu?.length && this.active;
  }

  isActiveRoute(actionDef: MngActionDef): boolean {
    if (actionDef.target) {
      const currentPath = this.location.path();
      const pathWithoutParams = removeParams(currentPath).substr(1);

      if (actionDef.targetComparePaths) {
        return actionDef.targetComparePaths.some((comparPath) => comparPath.startsWith(pathWithoutParams));
      }

      const targetWithoutParams = removeParams(actionDef.target[0]);
      const targetWithoutSlash =
        targetWithoutParams.charAt(0) === '/' ? targetWithoutParams.substr(1) : targetWithoutParams;
      return pathWithoutParams === targetWithoutSlash;
    }
    return false;
  }
}
